
import React from "react";
import { useTheme } from "@material-ui/core";
import HvIconBase from "./IconBase";

const sizeSelector = (iconSize, height, width) => {
  if (height && width) {
    return { width, height };
  }

  switch (iconSize) {
    case "XS":
      return { width: 12, height: 12 };
    default:
    case "S":
      return { width: 16, height: 16 };
    case "M":
      return { width: 32, height: 32 };
    case "L":
      return { width: 96, height: 96 };
  }
};

const PaintBucket = ({
  color,
  iconSize = "S",
  viewbox = "0 0 16 16",
  height,
  width,
  semantic,
  inverted = false,
  svgProps,
  ...others
}) => {
  const theme = useTheme();
  const getColor = c => theme.palette?.[c] || c;
  const colorArray = 
    (typeof color === "string" && [getColor(color)]) ||
    (Array.isArray(color) && color.map?.(getColor)) ||
    [theme.palette.atmo2,theme.palette.acce1];

  if (semantic) {
    colorArray[0] = theme.palette?.[semantic] || colorArray[0];
  }

  if (inverted && colorArray[1]) {
    colorArray[1] = colorArray[0];
    colorArray[0] = "none";
  }

  const size = sizeSelector(iconSize, height, width);

  return (
    <HvIconBase name="PaintBucket" iconSize={iconSize ?? "S"} {...others}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox={viewbox} height={size.height} width={size.width}   focusable={false} {...svgProps}>
  <path fill={colorArray[0]} className="color0"  d="M13.982 14.499a1 1 0 01-1-1 9.54835 9.54835 0 011-2.444 9.548 9.548 0 011 2.444 1 1 0 01-1 1z" />
  <path fill={colorArray[1]} className="color1"  d="M13.982 12.19a6.06145 6.06145 0 00-.5 1.318.5.5 0 001 0 6.08079 6.08079 0 00-.5-1.318m0-2.191s1.5 2.672 1.5 3.5a1.5 1.5 0 11-3 0c0-.828 1.5-3.5 1.5-3.5zm-1.17-2.963l-6.928-4-4 6.928 6.928 4 4-6.928m1.366-.366l-5 8.66-8.66-5 4.5-7.794-1.732-1 .5-.866z" />
</svg>
    </HvIconBase>
)};

PaintBucket.propTypes = HvIconBase.propTypes;

export default PaintBucket;